import { useState } from 'react';
import adminService from 'services/admin';
import { diccionarioVista } from '../utils/utils';
import { AlertaError, AlertaExito, AlertaWarning } from 'utils/Alertas';

export const useSubmitGrupos = (codigoGrupo, values) => {
  const [isLoading, setIsLoading] = useState(true);
  const [grupos, setGrupos] = useState({
    nombreGrupo: ''
  });
  const [cargaData, setcargaData] = useState(false);

  /**
   * @name cargarGrupo
   * Función para cargar el grupo que se está desplegando, en el caso de que el código no viene se asume que es un nuevo grupo
   * @throws Error
   * @return estructura servicio de grupos
   */

  const cargarGrupo = async () => {
    setIsLoading(true);
    if (!codigoGrupo) {
      setIsLoading(false);
      return;
    }
    if (codigoGrupo !== 'nuevo') {
      try {
        const responseGrupo = await adminService.getGrupo(codigoGrupo);
        // console.log('responseGrupo', responseGrupo);

        const grupo = responseGrupo.data;
        // Filtrar para que no se repitan nombres dentro del mismo negocio.
        const uniqueData = grupo.empresas.reduce(
          (acc, item) => {
            const key = `${item.codigoGrupoEmpresa}-${item.empresa.nombreEmpresa}`;
            if (!acc.map.has(key)) {
              acc.map.set(key, true);
              acc.result.push({
                ...item.empresa,
                codigoGrupoEmpresa: item.codigoGrupoEmpresa
              });
            }
            return acc;
          },
          { map: new Map(), result: [] }
        ).result;

        if (responseGrupo.status === 200) {
          setGrupos({
            coodigoGrupo: grupo.codigoGrupo,
            nombreGrupo: grupo.nombreGrupo,
            empresas: uniqueData || [],
            usuarios: grupo.usuarios
          });
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        console.error('Error en cargaGrupo', error);
      } finally {
        setIsLoading(false);
        setcargaData(true);
      }
    } else {
      setIsLoading(false);
      setcargaData(true);
    }
  };

  /**
   * @name handleSubmit
   * Función para enviar los datos del formulario al servicio
   * @param valores estructura formik para nuevo/edicion grupo
   * @return estructura servicio nuevo/edicion grupo
   * @throws Error
   */

  const handleSubmit = async (valores, tipoFormulario) => {
    try {
      if (tipoFormulario === 'ingresar') {
        await submitNuevoGrupo(valores, tipoFormulario);
      } else if (tipoFormulario === 'editar') {
        await submitActualizarGrupo(valores);
      }
    } catch (error) {
      console.log('Error en handleSubmit ', error);
      AlertaError(
        `No se ha podido realizar la operación de ${diccionarioVista.primerNombrePrincipal}. Por favor, intente nuevamente.`
      );
      throw new Error('Error en handleSubmit ', error);
    }
  };

  /**
   * @name submitNuevoGrupo
   * Función para enviar los datos del nuevo grupo
   * @param valores estructura formik
   * @return estructura servicio nuevo grupo
   * @throws Error
   *
   * */

  const submitNuevoGrupo = async (valores, tipoFormulario) => {
    const generar = tipoFormulario === 'ingresar' && 'crear';
    const generarado = tipoFormulario === 'ingresar' && 'creado';
    try {
      const gruposData = estructuraServicioNuevoGrupo(valores);
      // console.log('gruposData', gruposData);
      const response = await adminService.postGrupo(gruposData);

      const { status } = response;

      if (status === 200) {
        AlertaExito(
          `Se ha ${generarado} el ${diccionarioVista.primerNombrePrincipal} correctamente`
        );
      } else {
        AlertaError(
          `No se ha podido ${generar} la operación de crear un ${diccionarioVista.primerNombrePrincipal}. Por favor, intente nuevamente.`
        );
      }
    } catch (error) {
      if (!error) return;

      AlertaError(
        `No se ha podido ${generar} la operación de crear un ${diccionarioVista.primerNombrePrincipal}. Por favor, intente nuevamente.`
      );
      throw new Error('Error en submitNuevoGrupo ', error);
    }
  };

  /**
   * @name submitActualizarGrupo
   * Función para enviar los datos del formulario al servicio
   * @param valores estructura formik para la edición de un grupo
   * @return estructura servicio de actualización de grupo
   * @throws Error
   *
   * */

  const submitActualizarGrupo = async valores => {
    try {
      const grupoData = estructuraServicioActualizarGrupo(valores);
      const response = await adminService.putGrupo(codigoGrupo, grupoData);
      if (response.status === 200) {
        AlertaExito(
          `Se ha actualizado el ${diccionarioVista.primerNombrePrincipal} correctamente`
        );
      } else {
        AlertaError(
          `No se ha podido realizar la operación de actualizar un ${diccionarioVista.primerNombrePrincipal}. Por favor, intente nuevamente.`
        );
      }
    } catch (error) {
      console.log('Error en submitActualizarGrupo ', error);
      AlertaError(
        `No se ha podido realizar la operación de actualizar un ${diccionarioVista.primerNombrePrincipal}. Por favor, intente nuevamente.`
      );
      throw new Error('Error en submitActualizarGrupo ', error);
    }
  };

  /**
   * @name handleEliminarGrupo
   * Función para eliminar un  grupo
   *
   * @param codAdquirido codigo del grupo a eliminar
   * @param cargaGrupos función para cargar el listado de grupos
   * @return estructura servicio de eliminación de grupo
   * @throws Error
   *
   * */
  const handleEliminarGrupo = async (codigoGrupo, cargaGrupos) => {
    try {
      const response = await adminService.deleteGrupo(codigoGrupo);
      if (response.status === 200) {
        AlertaExito(
          `Se ha eliminado el ${diccionarioVista.primerNombrePrincipal} correctamente`
        );
        cargaGrupos();
      } else {
        AlertaError(
          `No se ha podido realizar la operación de eliminar un ${diccionarioVista.primerNombrePrincipal}. Por favor, intente nuevamente.`
        );
      }
    } catch (error) {
      console.log('Error en handleEliminarGrupo ', error);
      AlertaError(
        `No se ha podido realizar la operación de eliminar un ${diccionarioVista.primerNombrePrincipal}. Por favor, intente nuevamente.`
      );
      throw new Error('Error en handleEliminarGrupo ', error);
    }
  };

  /**
   * @name estructuraServicioNuevoGrupo
   * Función para estructurar los valores del formulario a la estructura requerida por el servicio
   * @param valores estructura formik
   * @return estructura servicio nuevo grupo
   */
  const estructuraServicioNuevoGrupo = valores => {
    const requestPayload = valores.empresas.map(item => ({
      empresa: {
        codigoEmpresa: item.codigoEmpresa
      }
    }));
    // console.log('requestPayload', requestPayload);
    try {
      const estructuraServicio = {
        nombreGrupo: valores.nombreGrupo,
        empresas: requestPayload
      };
      return estructuraServicio;
    } catch (error) {
      console.log('Error en obtenerEstructuraServicio ', error);
      throw new Error('Error en obtenerEstructuraServicio ', error);
    }
  };

  /**
   * @name estructuraServicioActualizarGrupo
   * Función para estructurar los valores del formulario a la estructura requerida por el servicio
   * @param valores estructura formik
   * @return estructura servicio actualizar grupo
   */

  const estructuraServicioActualizarGrupo = valores => {
    const requestPayload = valores.empresas.map(item => ({
      empresa: {
        codigoEmpresa: item.codigoEmpresa
      }
    }));
    try {
      const estructuraServicio = {
        nombreGrupo: valores.nombreGrupo,
        empresas: requestPayload
      };
      return estructuraServicio;
    } catch (error) {
      console.log('Error en obtenerEstructuraServicio ', error);
      throw new Error('Error en obtenerEstructuraServicio ', error);
    }
  };

  return {
    grupos,
    setGrupos,
    isLoading,
    setIsLoading,
    cargarGrupo,
    cargaData,
    handleSubmit,
    handleEliminarGrupo
  };
};
